<template>
  <div>
    <div class="loading" v-if="isLoading">
      <div class="sk-three-bounce">
        <div class="sk-child sk-bounce1"></div>
        <div class="sk-child sk-bounce2"></div>
        <div class="sk-child sk-bounce3"></div>
      </div>
    </div>
    <!-- Export Button -->
    <b-row class="mb-3" v-if="$can('export')">
      <b-col sm>
        <div>
          <button
            type="button"
            class="btn btn-success"
            @click="exportTable"
            :disabled="isLoadingButton || !isParams"
          >
            <div
              class="d-inline-flex sk-three-bounce custom-loading-bounce"
              v-if="isLoadingButton"
            >
              <div class="sk-child sk-bounce1"></div>
              <div class="sk-child sk-bounce2"></div>
              <div class="sk-child sk-bounce3"></div>
            </div>
            <span v-else>
              Export
            </span>
          </button>
        </div>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <!-- Filter Partner -->
      <b-col sm="6">
        <div>
          <b-form-group class="mb-3">
            <label for="sp">
              Partner
            </label>
            <b-form-select id="sp" v-model="filterPartner" :options="partnerOptions"></b-form-select>
          </b-form-group>
        </div>
      </b-col>
      <!-- Filter Date -->
      <b-col sm="6">
        <div>
          <b-form-group
            class="mb-3"
            label="Date :"
            label-for="daterange"
            :state="dateRangeState === false ? false : computedDateRequiredState"
          >
            <template #invalid-feedback>
              <span v-if="dateRangeState === false">
                The date range must be at least 1 day
              </span>
              <span v-else-if="computedDateRequiredState === false">
                Date range is required when using partner/status filters without specific search
              </span>
            </template>
            <b-input-group>
              <b-input-group-prepend is-text>
                <i class="fa fa-calendar"></i>
              </b-input-group-prepend>
              <range-picker
                id="daterange"
                :start="startDate"
                :end="endDate"
                :type="'clear'"
                :disable="false"
                :autoUpdate="false"
                :timePicker="false"
                @picker="doDateFilter"
              ></range-picker>
              <b-input-group-append>
                <b-button type="button" variant="secondary" @click="resetDateFilter">Reset</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
      </b-col>
      <!-- Filter Search -->
      <b-col sm="6">
        <div>
          <b-form-group
            class="mb-3"
            label="Search :"
            label-for="search"
          >
            <b-input-group
            >
              <b-input-group-prepend>
                <b-dropdown :text="typeFilter" v-model="typeFilter" variant="secondary">
                  <b-dropdown-item v-for="(item, index) in typeData" :key="index" @click="typeFilter = item.value; placeholder = item.placeholder">
                    {{item.text}}
                  </b-dropdown-item>
                </b-dropdown>
              </b-input-group-prepend>
              <b-form-input
                id="search"
                type="search"
                v-model="filterText"
                :placeholder="placeholder"
              >
              </b-form-input>
              <b-input-group-append
              >
                <b-button
                  type="button"
                  variant="secondary" @click="resetFilter"
                >
                  Reset
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
      </b-col>
      <!-- Filter Attempt Count -->
      <b-col sm="6">
        <div>
          <b-form-group
            class="mb-3"
            label-for="sp"
            label="Attempt Count :"
          >
            <b-form-select id="sp" v-model="filterAttempt" :options="
            [
              { value: '', text: 'Filter By Attempt Count' },
              { value: '0', text: '1 -  2' },
              { value: '1', text: '3 - 5 ' },
              { value: '2', text: '6 - 9' },
              { value: '3', text: 'More Than 10' },
            ]"></b-form-select>
          </b-form-group>
        </div>
      </b-col>
      <!-- Filter KTP Status -->
      <b-col sm="6">
        <div>
          <b-form-group
            class="mb-3"
            label-for="sp"
            label="KTP Status :"
          >
            <b-form-select id="sp" v-model="filterKtp" :options="
            [
              { value: '', text: 'Filter By KTP Status' },
              { value: '0', text: 'Not Verified' },
              { value: '1', text: 'Verified' },
              { value: '2', text: 'Rejected' },
              { value: '3', text: 'On Process' },
              { value: '4', text: 'Submitted' }
            ]"></b-form-select>
          </b-form-group>
        </div>
      </b-col>
      <!-- Filter Selfie KTP Status -->
      <b-col sm="6">
        <div>
          <b-form-group
            class="mb-3"
            label="Selfie KTP Status :"
            label-for="sp"
          >
            <b-form-select id="sp" v-model="filterSelfie" :options="
            [
              { value: '', text: 'Filter By Selfie Status' },
              { value: '0', text: 'Not Verified' },
              { value: '1', text: 'Verified' },
              { value: '2', text: 'Rejected' },
              { value: '3', text: 'On Process' },
              { value: '4', text: 'Submitted' }
            ]"></b-form-select>
          </b-form-group>
        </div>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col sm>
        <b-button
          class="mb-2"
          @click="doFilter"
          :disabled="stateButton"
          :style="buttonStyle"
        >
          Apply Filter
        </b-button>
        <p class="mb-3" :style="{ color: 'rgba(115, 129, 143, 1)' }">
          Click button 'Apply Filter' to apply the filter
        </p>
      </b-col>
    </b-row>

    <b-skeleton-table
      v-if="isLoadingTable == true"
      :rows="10"
      :columns="10"
      :table-props="{ bordered: true }"
    ></b-skeleton-table>
    <vuetable
      v-else
      ref="vuetable"
      :api-mode="false"
      :fields="fields"
      :per-page="limit"
      :data-manager="dataManager"
      pagination-path="pagination"
      :no-data-template="isParams ? defaultTemplate : noDataTemplate"
    >
      <template slot="name-slot" slot-scope="prop">
        <span>{{ prop.rowData.name || '-' }}</span>
      </template>
      <template slot="email-slot" slot-scope="prop">
        <span>{{ prop.rowData.email || '-' }}</span>
      </template>
      <template slot="phone-slot" slot-scope="prop">
        <span>{{ prop.rowData.phone || prop.rowData.phone_number || '-' }}</span>
      </template>
      <template slot="partner-slot" slot-scope="prop">
        <span>{{ prop.rowData.partner_name || 'Treasury' }}</span>
      </template>
      <template slot="nik" slot-scope="prop">
        <span>{{ prop.rowData.ktp || '-' }}</span>
      </template>
      <template slot="attempt_count" slot-scope="prop">
        <span>{{ prop.rowData.kyc_attempt }}</span>
      </template>
      <template slot="actions-slot" slot-scope="prop">
        <div class="custom-actions" v-if="$can('kyc')">
          <button
            v-if="$can('update_verify_kyc')"
            type="button"
            class="btn btn-info m-1"
            @click="onAction('detail', prop.rowData, prop.rowIndex)"
          >
            Detail
          </button>
          <button
            v-if="$can('update_verify_kyc')"
            type="button"
            class="btn btn-warning m-1"
            @click="onAction('log-response', prop.rowData)"
          >
            LOG
          </button>
        </div>
      </template>
    </vuetable>
    <div
      v-show="isParams"
      class="vuetable-pagination ui basic segment grid"
    >
      <div class="wrapper-pagination-custom">
        <div class="pagination-custom-info">
          <p>{{ this.paginationInfo }}</p>
        </div>
        <div class="pagination-custom-button">
          <button :disabled="current_page === 1" @click="doMovePage('first')">
            <i
              v-if="current_page === 1"
              class="fa fa-angle-double-left disabled"
            ></i>
            <i v-else class="fa fa-angle-double-left"></i>
          </button>
          <button :disabled="current_page === 1" @click="doMovePage('prev')">
            <i v-if="current_page === 1" class="fa fa-angle-left disabled"></i>
            <i v-else class="fa fa-angle-left"></i>
          </button>
          <div>{{ this.current_page }}</div>
          <button :disabled="data.length < 10" @click="doMovePage('next')">
            <i v-if="data.length < 10" class="fa fa-angle-right disabled"></i>
            <i v-else class="fa fa-angle-right"></i>
          </button>
        </div>
      </div>
    </div>

    <b-modal v-if="$can('kyc')" :title="logTitle" size="lg" v-model="logModal" @ok="logModal = false" centered hide-footer>
      <div class="wrapper-log-detail" v-if="log.detail_log && log.detail_log.length === 0">
        <p>Data Belum Tersedia!</p>
      </div>
      <div v-else>
        <b-card no-body  v-for="(item,index) in log.detail_log" :key="item.title" class="mb-2">
          <b-card-header header-tag="header" class="p-1 bg-light" role="tab">
            <!-- <h5 v-b-toggle.accordion-3>Attempt 1</h5> -->
            <b-button block v-b-toggle="'accordion-'+index" class="text-left font-weight-bold" variant="light">{{item.title}}</b-button>
          </b-card-header>
          <b-collapse :id="'accordion-'+index" class="p-2">
            <div class="d-flex align-items-start justify-content-between mb-3" v-for="items in item.logs" :key="items.id">
              <div class="d-flex align-items-start justify-content-center">
                <div class="status-icon status-icon-success" v-if="items.status === 'success'"><i class="fa fa-check"></i></div>
                <div class="status-icon status-icon-failed" v-else-if="items.status === 'failed'"><i class="fa fa-times"></i></div>
                <div class="status-icon status-icon-pending" v-else-if="items.status === 'pending'"><i class="fa fa-clock-o"></i></div>
                <div class="ml-3 d-flex flex-column" :style="{ width: '560px' }">
                  <p class="mb-1">{{items.title}}</p>
                  <!-- <p class="text-success mb-1" v-if="items.status === 'success' && items.reason && (items.type === 'smma' || items.type === 'edit-ktp' || items.type === 'edit-selfie')">{{items.reason}}<br/> <b>Verified</b></p> -->
                  <p class="text-success mb-1" v-if="items.status === 'success' && items.message">{{items.message}}<br/> <b>Verified</b></p>
                  <p class="text-danger mb-1" v-else-if="items.status === 'failed' && items.message"><b>Rejected</b> <i>({{items.message}})</i></p>
                  <p class="text-warning mb-1" v-else-if="items.status === 'pending' && items.message"><b>Pending</b> <i>({{items.message}})</i></p>
                  <p class="mb-1" v-else-if="items.message">{{items.message}}</p>
                  <a v-if="items.attachment" target="_blank" :href="imageUrl(items.attachment)" alt="" class="text-info">
                    Lihat Foto
                  </a>
                </div>
              </div>
              <p class="text-nowrap">{{items.created_at}}</p>
            </div>
          </b-collapse>
        </b-card>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import $ from 'jquery'
  import _ from 'lodash'
  import Vue from 'vue'
  import moment from "moment";
  import accounting from 'accounting'
  import Vuetable from 'vuetable-2/src/components/Vuetable'
  import dotenv from 'dotenv'
  import axios from  'axios'

  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`

  dotenv.config()

  Vue.use(Vuetable);

  export default {
    components: {
      Vuetable
    },
    prop: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      },
    },
    data() {
      return {
        count: 0,
        page: 1,
        current_page: 1,
        limit: 10,
        data: [],
        dataLength: 0,
        paginationInfo: '',
        filterPartner: '',
        filterKtp: '',
        filterSelfie: '',
        filterAttempt: '',
        startDate: '',
        endDate: '',
        dateRangeState: null,
        dateRequiredState: null,
        form: {
          npwpReason: ''
        },
        errors: {
          code: '',
          message: '',
          status: ''
        },
        warning_message: '',
        isLoading: false,
        isLoadingTable: false,
        isLoadingButton: false,
        baseUrlPath: process.env.VUE_APP_SECRET,
        from: '',
        selected: [],
        partnerOptions: [
          { value: '', text: 'Select Partner'}
        ],
        logModal: false,
        mydate: '',
        filterText: '',
        typeFilter: 'Email',
        typeData : [
          {value:'Email', text:'Email', placeholder:'Search by Email' },
          {value:'NIK', text:'NIK', placeholder:'Search by NIK' },
          {value:'Phone', text:'Phone', placeholder:'Search by Phone' },
        ],
        apiUrl: process.env.VUE_APP_SECRET + process.env.VUE_APP_CONFIG +  `partner/verify`,
        HttpOptions: {
          headers: {
            'Accept' : 'application/json',
            'Authorization' : 'Bearer ' + localStorage.getItem('access_token')
          }
        },
        sort: 'updated|desc',
        sortOrder: [
          {
            field: 'updated',
            sortField: 'updated',
            direction: 'desc'
          }
        ],
        moreParams: {},
        fields: [
          {
            name: 'name-slot',
            sortField: 'name',
            title: 'Name'
          },
          {
            name: 'email-slot',
            sortField: 'email',
            title: 'Email'
          },
          {
            name: 'phone-slot',
            sortField: 'phone',
            title: 'Phone Number'
          },
          {
            name: 'partner-slot',
            sortField: 'partner_name',
            title: 'Partner'
          },
          {
            name: 'nik',
            sortField: 'nik',
            title: 'NIK',
            formatter: this.ktpValue
          },
          {
            name: 'ktp_status',
            sortField: 'ktp_status',
            title: 'Status KTP',
            formatter: this.statusValue
          },
          {
            name: 'selfie_status',
            sortField: 'selfie_status',
            title: 'Status Selfie',
            formatter: this.selfieValue
          },
          {
            name: 'attempt_count',
            sortField: 'attempt_count',
            title: 'Attempt Count',
            formatter: this.selfieValue
          },
          {
            name: 'updated',
            sortField: 'updated',
            title: 'Waktu Update'
          },
          {
            name: 'actions-slot',
            title: 'Actions',
            titleClass: 'center aligned',
            dataClass: 'center aligned'
          }
        ],
        log: [],
        logTitle:'',
        filtered: false,
        placeholder: 'Search by Email',
        noDataTemplate:
          '<div class="text-center d-flex align-items-center justify-content-center" style="height: 120px;"><p>Use filter to show your data.</p></div>',
        defaultTemplate:
          '<div class="text-center d-flex align-items-center justify-content-center flex-column" style="height: 120px;"><p><strong>No results found.</strong></p><p>Please adjust your filter or search keywords</p></div>',
      }
    },
    computed: {
      computedDateRequiredState() {
        // Check if date is required based on active filters
        const hasPartnerFilter = this.filterPartner !== "";
        const hasKtpFilter = this.filterKtp !== "";
        const hasSelfieFilter = this.filterSelfie !== "";
        const hasAttemptFilter = this.filterAttempt !== "";
        const dateRangeEmpty = [this.startDate, this.endDate].every((f) => f === "");
        const hasFreetextFilter = this.filterText !== "";
        
        // Rule 3: If freetext is filled, date is not required (overrides rule 1)
        if (hasFreetextFilter) {
          return null;
        }
        
        // Rule 1: Date is required when any category filter is active without freetext
        if ((hasPartnerFilter || hasKtpFilter || hasSelfieFilter || hasAttemptFilter) && dateRangeEmpty) {
          return false; // Invalid state
        }
        
        return null; // Valid state
      },
      stateButton() {
        const allFiltersEmpty = [
          this.startDate,
          this.endDate,
          this.filterText,
          this.filterPartner,
          this.filterAttempt,
          this.filterKtp,
          this.filterSelfie,
        ].every((f) => f === "");
        
        // Disable if all filters are empty
        if (allFiltersEmpty) return true;
        
        // Disable if there's a date range validation error
        if (this.dateRangeState === false) return true;
        
        // Check filter types
        const hasPartnerFilter = this.filterPartner !== "";
        const hasKtpFilter = this.filterKtp !== "";
        const hasSelfieFilter = this.filterSelfie !== "";
        const hasAttemptFilter = this.filterAttempt !== "";
        const hasDateFilter = this.startDate !== "" || this.endDate !== "";
        const hasFreetextFilter = this.filterText !== "";
        
        // Rule 2 & 3: If freetext is filled, date is not required
        if (hasFreetextFilter) {
          return false;
        }
        
        // Rule 1: If has category filter without freetext, date is required
        if ((hasPartnerFilter || hasKtpFilter || hasSelfieFilter || hasAttemptFilter) && !hasDateFilter) {
          return true;
        }
        
        return false;
      },
      buttonStyle() {
        return {
          background: !this.stateButton ? "#7565F6" : "#c8ced3",
          color: !this.stateButton ? "#FFFFFF" : "inherit"
        };
      },
      isParams() {
        const params =
          // eslint-disable-next-line no-unused-vars
          Object.entries(this.moreParams).filter(([key, value]) => value)
            .length == 0;

        return !params && !this.isLoadingTable;
      },
    },
    watch: {
      // eslint-disable-next-line no-unused-vars
      data(newVal, oldVal) {
        if (
          this.$refs.vuetable &&
          typeof this.$refs.vuetable.refresh === "function"
        ) {
          this.$refs.vuetable.refresh();
        }
      },
      logModal(value) {
        if (!value) this.log = [];
      },
    },
    created () {
      this.onFetchPartner();

      this.$events.$on("apply-filter", this.onFilterSet);
      this.$events.$on('movePage', this.onMovePage);
      this.$events.$on('date-set', this.onDateSet);
      this.$events.$on('date-filter-reset', this.onDateFilterReset);
      this.$events.$on('city-set', this.onSearchCitySet)
    },
    beforeDestroy() {
      this.$events.$off("apply-filter", this.onFilterSet);
      this.$events.$off('movePage', this.onMovePage)
      this.$events.$off('date-set', this.onDateSet)
      this.$events.$off('date-filter-reset', this.onDateFilterReset)
      this.$events.$off('city-set', this.onSearchCitySet)
    },
    methods: {
      async onAction (action, data) {
        if (action == 'detail') {
          const routeData = this.$router.resolve({name: 'Detail Verifikasi Partner', params: { id: btoa(data.id) }});
          window.open(routeData.href, '_blank');
        } else if (action === 'npwp-item') {
          this.$http.put(`verify/` + data.id)
            .then((result) => {
              this.from = result.data.from;
              this.npwpNumber = result.data.verify.taxpayer_number;
              this.npwpUrl = result.data.verify.taxpayer_number_scan;
              this.npwpStatus = result.data.verify.npwp_status;
              this.form.npwpReason = result.data.verify.npwp_reason;
              this.params = result.data.verify.id;
            }).catch((error) => {
              if (error.response) {
                this.errors.code = error.response.status;
                this.errors.message = error.response.data.meta.message;
                this.errors.status = error.response.data.meta.code;
              }
            })
        } else if (action === 'log-response') {
          this.$http.get(`partner/kyc-logs?user_id=` + data.id)
            .then((result) => {
              this.logModal = true;
              this.log = result.data.data;
              this.logTitle = `Log Detail (${this.log.name} - ${this.log.email})`
            }).catch((error) => {
              if (error.response) {
                this.errors.code = error.response.status;
                this.errors.message = error.response.data.meta.message;
                this.errors.status = error.response.data.meta.code;
              }
            })
        }
      },
      exportTable() {
        this.isLoadingButton = true;
        const isDate = this.moreParams.start_from && this.moreParams.end_to;
        const dateParams = isDate
          ? `/${this.moreParams.start_from}/${this.moreParams.end_to}`
          : '';
        const newParams = Object.entries(this.moreParams)
          // eslint-disable-next-line no-unused-vars
          .filter(([key, value]) => !['start_from', 'end_to'].includes(key) && value !== '' && value != null)
          .map(([key, value]) => `${key}=${value}`)
          .join("&");

        this.$http.get(`/ktp-partner${dateParams}?sort=${encodeURIComponent(this.sort)}${newParams ? `&${newParams}` : ""}`)
          .then((result) => {
            this.isLoadingButton = false
            const  exportPath = result.data.meta.data;
            window.location.href = exportPath;
          }).catch((error) => {
            this.handleLoadError(error)
          })
      },
      onFetch() {
        const newParams = Object.entries(this.moreParams)
          // eslint-disable-next-line no-unused-vars
          .filter(([_, value]) => value !== '' && value != null)
          .map(([key, value]) => `${key}=${value}`)
          .join("&");
          
        this.isLoadingTable = true;
        this.data = [];

        this.$http.get(`partner/verify?sort=${encodeURIComponent(this.sort)}&page=${this.page}&per_page=10${newParams ? `&${newParams}` : ""}`)
          .then((response) => {
            const datas = response.data.data;
            const datasCount = datas.length;
            const startIndex = (response.data.current_page - 1) * this.limit;
            const endIndex = Math.min(
              startIndex + this.limit,
              datasCount > 0 ? datasCount + startIndex : this.limit
            );

            this.data = datas;
            this.current_page = response.data.current_page;
            this.paginationInfo =
              datas.length > 0
                ? `Displaying ${startIndex + 1} to ${endIndex}`
                : "No relevant data";

            this.isLoadingTable = false;
          })
          .catch((err) => {
            this.isLoadingTable = false;
            this.handleLoadError(err)
          })
      },
      onFetchPartner() {
        this.$http.get(`partner-list`)
          .then((response) => {
            const newPartner = response.data.map((item) => { return { value: item.id, text: item.name } })
            this.partnerOptions = [
              ...this.partnerOptions,
              ...newPartner
            ]
            this.loadingPage = false
          })
      },
      dataManager(sortOrder, pagination) {
        let local = this.data;

        if (sortOrder.length > 0) {
          const newSort = `${sortOrder[0].sortField}|${sortOrder[0].direction}`;

          if (this.sort !== newSort) {
            this.sort = newSort;
            this.onFetch();
          }
        }

        pagination = this.$refs.vuetable.makePagination(
          local.length,
          this.limit
        );

        let from = pagination.from - 1;
        let to = from + this.limit;

        return {
          pagination: pagination,
          data: local.length > 0 ? _.slice(local, from, to) : []
        };
      },
      onChangePage (page) {
        this.$refs.vuetable.changePage(page)
      },
      onPaginationData (paginationData) {
        this.$refs.pagination.setPaginationData(paginationData)
        this.$refs.paginationInfo.setPaginationData(paginationData)
      },
      doMovePage(value) {
        this.$events.$emit('movePage', value)
      },
      async onMovePage(eventData) {
        if (eventData === 'first') {
          this.page = 1;
          this.onFetch();
        } else if (eventData === 'prev') {
          this.page--;
          this.onFetch();
        } else {
          this.page++;
          this.onFetch();
        }
      },
      handleLoadError(error) {
        const code = error.response.data.meta.code;
        const message = error.response.data.meta.message;

        this.errors.code = code;
        this.errors.message = message;
        this.errors.status = code;
        this.isLoading = false;
        this.isLoadingTable = false;
        this.isLoadingButton = false;

        if (this.errors.code == 401) {
          this.$swal
            .fire(
              "Your session expired!",
              "Your session has expired. Please login again to access this page!",
              "error"
            )
            .then(() => {
              this.$router.push("/login");
            });
        } else if (this.errors.code == 403) {
          this.$router.push("/403");
        } else {
          this.$swal.fire("An error occured", message, "error").then(() => {
            this.$router.reload();
          });
        }
      },
      doFilter() {
        this.$events.$emit("apply-filter");
      },
      onFilterSet() {
        this.page = 1;
        this.moreParams = {
          start_from: this.startDate,
          end_to: this.endDate,
          ...(this.filterText && { typeFilter: this.typeFilter }),
          filter: encodeURIComponent(this.filterText),
          partner: this.filterPartner,
          attempt_filter: this.filterAttempt,
          id_number: this.filterKtp,
          selfie_status: this.filterSelfie,
        };
        this.onFetch();
      },
      resetFilter () {
        this.filterText = ''
      },
      doDateFilter(value){
        this.$events.fire('date-set', value)
      },
      onDateSet(value)  {
        const startDate = moment(value.startDate);
        const endDate = moment(value.endDate);
        
        // Calculate the difference in days
        // const daysDiff = endDate.diff(startDate, 'days');
        
        // Must be at least 1 day difference
        // if (daysDiff < 1) {
        //   this.dateRangeState = false;
        //   return;
        // }
        
        // Valid range
        this.dateRangeState = null;
        this.startDate = startDate.format("YYYY-MM-DD");
        this.endDate = endDate.format("YYYY-MM-DD");
      },
      resetDateFilter () {
        this.startDate = ''
        this.endDate = ''
        this.dateRangeState = null
        // this.$events.$emit('date-filter-reset')
      },
      onDateFilterReset () {
        this.moreParams = Object.fromEntries(
          Object.entries(this.moreParams).filter(([key, value]) => {
            return [key, key !== "start_from" && key !== "end_to" ? value : ""];
          })
        );
      },
      doSearchCity(city) {
        let cities = []
        for (let index = 0; index < city.length; index++) {
          cities.push(city[index].value)
        }

        this.$events.$emit('city-set', cities.toString())
      },
      onSearchCitySet(selected) {
        this.filterKtp = ''
        this.filterNpwp = ''
        this.filterSelfie = ''
        this.moreParams = {
          'city': selected
        }
        Vue.nextTick( () => this.$refs.vuetable.refresh())
      },
      notRejectedKtp() {
        $('#ktpReason').css("display", "none");
      },
      rejectedKtp() {
        $('#ktpReason').css("display", "block");
      },
      notRejectedSelfie() {
        $('#selfieReason').css("display", "none");
      },
      rejectedSelfie() {
        $('#selfieReason').css("display", "block");
      },
      ktpValue(value) {
        return value != null ? value : '<font color="gray">Not Found</font>'
      },
      statusValue (value) {
        if (value == 0) {
          return '<font class="text-gray">Not Verified</font>'
        }else if(value == 1){
          return '<font class="text-green">Verified</font>'
        }else if(value == 2){
          return '<font class="text-red">Rejected</font>'
        }else if(value == 3){
          return '<font class="text-warning">On Process</font>'
        }else if(value == 4){
          return '<font>Submitted</font>'
        }else{
          return '<span> - </span>'
        }
      },
      actionValue (value) {
        if (value == 0) {
          return '<span>Belum Diverifikasi</span>'
        }else if(value == 1){
          return '<span>AsliRI</span>'
        }else if(value == 2){
          return '<span>Admin</span>'
        }else{
          return '<span> - </span>'
        }
      },
      selfieValue (value) {
        if (value == 0) {
          return '<font class="text-gray">Not Verified</font>'
        }else if(value == 1){
          return '<font class="text-green">Verified</font>'
        }else if(value == 2){
          return '<font class="text-red">Rejected</font>'
        }else if(value == 3){
          return '<font class="text-warning">On Process</font>'
        }else if(value == 4){
          return '<font>Submitted</font>'
        }else{
          return '<span> - </span>'
        }
      },
      getStatusColor(value) {
        return {
          'text-gray': value === 0,
          'text-green': value === 1,
          'text-red': value === 2,
          'text-warning': value === 3
        };
      },
      formatNumber (value) {
        return accounting.formatNumber(value, 2)
      },
      imageUrl(url){
        return 'https://content-dev.treasury.id/' + url
      },
    },
  }
</script>

<style lang="scss" scoped>
  .warning {
    color: #e0a800
  }

  footer.modal-footer {
      display: none;
  }
  .mx-datepicker {
    width: 100%
  }
  .mx-datepicker:disabled, .mx-datepicker.disabled {
    background-color: #e4e7ea !important;
    opacity: 1 !important;
  }
  input.mx-inpu:disabled {
    background-color: #e4e7ea !important;
    opacity: 1 !important;
  }
  .mx-input:disabled, .mx-input.disabled {
    background-color: #e4e7ea !important;
    opacity: 1 !important;
  }
</style>
<style>
.text-gray {
  color: rgb(128, 128, 128);
}

.text-info{
  color: #20A8D8;
}

.text-red {
  color: #CB211F;
}
.text-green {
  color: #35AA4B;
}
.text-warning {
  color: #A78F27;
}

.wrapper-log-detail {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Absolute Center Spinner */
.loading {
  position: fixed;
  z-index: 999;
  height: 2em;
  width: 2em;
  overflow: visible;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

/* Transparent Overlay */
.loading:before {
  content: '';
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
}

.v-select {
  padding-top: 23px;
}

/* Pagination Custom */
.wrapper-pagination-custom {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f9fafb;
}

.pagination-custom-button {
  display: flex;
}

.pagination-custom-button button {
  width: 28px;
  height: 47px;
  padding: 13px 16px;
  font-size: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FFFFFF;
  border: solid rgba(0,0,0,0.3);
}

.pagination-custom-button button:first-child {
  padding: 13px 16px 13px 30px;
  border-radius: 4px 0 0 4px;
  border-width: 1px 0 1px 1px
}

.pagination-custom-button button:nth-child(2),
.pagination-custom-button button:last-child {
  font-size: 1.3em;
  border-width: 1px;
}

.pagination-custom-button button:last-child {
  border-radius: 0 4px 4px 0;
}

.pagination-custom-button button i.disabled {
  opacity: 0.6;
}

.pagination-custom-button div {
  width: 28px;
  height: 47px;
  font-size: 1em;
  font-weight: 500;
  background: #FFFFFF;
  border: solid rgba(0,0,0,0.3);
  border-width: 1px 0 1px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-loading-bounce {
  width: 72px !important;
  height: 18px !important;
  margin: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
.custom-loading-bounce .sk-child {
  width: 6px !important;
  height: 6px !important;
  background: #ffffff !important;
}

/* Skeleton */
.skeleton-button,
.skeleton-type,
.skeleton-wrapper {
  margin-bottom: 20px;
}

.skeleton-title {
  height: 18px;
  margin-bottom: 10px;
}

.skeleton-ktp,
.skeleton-selfie,
.skeleton-filter,
.skeleton-date {
  margin-right: 30px;
}

.skeleton-wrapper {
  display: grid;
  grid-template-columns: auto auto auto;
}

/* Icon Status */
.status-icon {
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
}

.status-icon-success {
  color: #35AA4B;
  background: #F2F5F9;
}

.status-icon-failed {
  color: #CB211F;
  background: #FAE9E9;
}

.status-icon-pending {
  color: #D1B331;
  background: #FAF7EA;
}
</style>
<style src="spinkit/scss/spinkit.scss" lang="scss" />
